import styled from "@emotion/styled";
import { Box, Typography } from "@mui/material";
import { Colors } from "../theme";

export const LoginContain = styled(Box)(() => ({
  backgroundColor: Colors.color,
  width: "100%",
  height: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  position: "relative",
  overflow: "hidden",
  "&::before, &::after": {
    content: '""',
    position: "fixed",
    width: "135px",
    height: "135px",
    borderRadius: "50%",
    backgroundColor: Colors.primary,
    boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
    zIndex: 1,
  },
  "&::before": {
    bottom: "-70px",
    left: "-70px",
  },
  "&::after": {
    top: "-70px",
    right: "-70px",
  },
  "& .LoginLogo": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    maxWidth: "500px",
    width: "100%",
    margin: "auto",
    "& img": {
      width: "60px",
    },
  },
  "& .LoginCard": {
    maxWidth: "500px",
    width: "100%",
    padding: "40px",
    backgroundcolor: Colors.text,
    borderRadius: "15px",
    boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.1)",
    border: "1px solid " + Colors.border,
    "& .LoginTitle": {
      marginBottom: "30px",
      "& h4": {
        fontSize: "28px",
        color: Colors.primary,
        textAlign: "center",
      },
      "& p": {
        textAlign: "center",
        fontSize: "14px",
        color: "gray",
      },
    },
    "& .LoginGroup": {
      marginBottom: "20px",
      "& label": {
        display: "block",
        fontSize: "14px",
        color: Colors.primary,
        marginBottom: "5px",
      },
      "& input": {
        width: "100%",
        padding: "10px",
        borderRadius: "8px",
        border: "1px solid #ccc",
        outline: "none",
        fontSize: "14px",
        backgroundColor: "#f9f9f9",
      },
      "& .password-container": {
        position: "relative",
        display: "flex",
        alignItems: "center",
        "& input": {
          flex: 1,
          paddingRight: "40px", // Add space for the toggle icon
        },
        "& .password-toggle-icon": {
          position: "absolute",
          right: "10px",
          cursor: "pointer",
          width: "20px",
          height: "20px",
        },
      },
    },
    "& .LoginBtn": {
      textAlign: "center",
      "& button": {
        padding: "10px 20px",
        fontSize: "16px",
        backgroundColor: Colors.primary,
        color: Colors.text,
        border: "none",
        borderRadius: "8px",
        cursor: "pointer",
        transition: "background-color 0.3s ease",
        "&:hover": {
          backgroundColor: Colors.hover,
        },
      },
      "& button:disabled": {
        backgroundColor: "#ccc",
        cursor: "not-allowed",
      },
    },
    "& .CheckBox": {
      textAlign: "right",
      "& a": {
        fontSize: "12px",
        color: Colors.primary,
        textDecoration: "none",
        "&:hover": {
          textDecoration: "underline",
        },
      },
    },
  },
}));

export const LoginFooter = styled(Box)(() => ({
  backgroundColor: "#f5f5f5",
  color: Colors.grayText,
  padding: "10px",
  position: "fixed",
  bottom: "0",
  left: "0",
  width: "100%",
  "& p": {
    margin: "0",
    fontSize: "10px",
    textAlign: "center",
    "& span": {
      color: Colors.primary,
    },
  },
}));

export const Error = styled(Typography)(() => ({
  color: "red",
  fontSize: "12px",
  marginTop: "5px",
}));

export const RequiredStar = styled("span")(() => ({
  color: "#d9534f",
  marginLeft: "2px",
}));
